import { TitleCasePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree,Router } from '@angular/router';
import { th } from 'date-fns/locale';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {
  loginStatus: boolean = false;
  constructor(
    private router: Router,
  ) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      
      // ;
     this.loginStatus = localStorage.getItem("user_session_id") ? true : false;

      if(this.loginStatus === true)
      {
        return true;
      }
      else
      {
        this.router.parseUrl('/');
        return false
        // return true;
      }

  }

}
